import { Clickstream } from "./Clickstream";
import { setTrackJsContext, trackJsInfo } from "./trackjs";

let _context = null;

let _eventData = {
    version: VERSION
};

let _elasticMonitoring = new Clickstream(`${__webpack_public_path__}api/event/`, "web-bankidauthenticator");

function setContext(context) {

    if (context !== null) {

        _context = Object.assign(_context || {}, context);

        _elasticMonitoring.setClientLanguage(context.lang);
        _elasticMonitoring.setSubBrandId(context.subBrandId);
        _elasticMonitoring.setBrandId(context.brandId);
        _elasticMonitoring.setParentProductPackage(context.clientProductPackage);
        _elasticMonitoring.setSystemId(context.systemId);

        if (typeof context.sessionId === "string") {
            _elasticMonitoring.setCustomHeaders({ "XX-SessionId": context.sessionId });
        }
    }

    setTrackJsContext(_context);
}


function monitor(eventName, eventProps) {

    try {
        trackJsInfo(eventName, eventProps);

        let eventData = Object.assign({}, _eventData);

        if (typeof eventProps === "object") {
            eventData = Object.assign(eventData, eventProps);
        }

        if (_context !== null) {
            eventData.context = _context;
        }

        _elasticMonitoring.reportInfo(eventName, eventData);
    }
    catch (e) {
        // ignore
    }
}

export { monitor, setContext };